import { ActionsUnion, createAction } from "../definitions";
import { ITrailerAttachment } from "../../model/TrailerAttachment";
import { TrailerAttachmentActionTypes } from "./types";

export class ITrailerAttachmentPayload {
    userId: string;
    trailerAttachments: IIdDictionary<ITrailerAttachment>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const TrailerAttachmentActions = {
    setTrailerAttachments: (payload: ITrailerAttachmentPayload) => createAction(TrailerAttachmentActionTypes.SET_TRAILER_ATTACHMENTS, payload),
    clearTrailerAttachments: (payload: string) => createAction(TrailerAttachmentActionTypes.CLEAR_TRAILER_ATTACHMENTS, payload)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TrailerAttachmentActions = ActionsUnion<typeof TrailerAttachmentActions>;